module.exports = __webpack_public_path__ + "static/media/icon_qualitygoals_blue.07022f63.svg";